'use client'

import { openCalendly } from '@/components/ui/calendly-button'

export function SocialProofCtaButton({ label }: { label: string }) {
  return (
    <button
      type="button"
      onClick={openCalendly}
      className="mt-8 inline-block rounded-full bg-white px-8 py-3 text-sm font-semibold uppercase tracking-[0.04em] text-blue transition-colors duration-200 hover:bg-bg-off"
    >
      {label}
    </button>
  )
}
